import React, { useState } from 'react';
import { Box, Typography, CircularProgress, Button, Paper, List, ListItem } from '@mui/material';
import DocumentScanner from '../../components/DocumentScanner';

const MOCK_RESULT = {
  "verordnung": {
    "krankenkasse": "DAK-Gesundheit",
    "versicherter": {
      "name": "Mark Kießlin",
      "geburtsdatum": "1989-01-19"
    },
    "verordnungsnummer": "421310200",
    "verordnungsdatum": "2025-06-09",
    "arzt": {
      "name": "Dr. med. Raschka",
      "betriebsstaettennummer": "421310200"
    },
    "diagnose": "Wundheilungsstörung nach offener Fraktur",
    "hilfsmittel": {
      "bezeichnung": "Orthopädische Maßschuhe bei struktureller Schädigung / Wundheilungsstörung",
      "produktgruppe": "31",
      "vermutete_hmv_position": "31.00.03.3001",
      "typ": "C 1 – Erstversorgung Straßenschuhe",
      "anzahl": 1,
      "preis_euro": 1437.64
    },
    "leistungserbringer": {
      "ik": "4213102004",
      "name": "Unbekannt (aus Rezept ersichtlich)",
      "pq_vorhanden": true
    }
  },
  "pruefung": {
    "verordnungswert_ueber_freigrenze": true,
    "genehmigungspflichtig": true,
    "genehmigungsfreigrenze_euro": 250.0,
    "verordnungswert_euro": 1437.64,
    "entscheidung": "nicht direkt abgebbar",
    "voraussetzungen_fuer_abgabe": [
      "Einreichung eines elektronischen Kostenvoranschlags (eKV)",
      "Verwendung des Dokumentationsbogens 'Sonstige Indikationen'",
      "DAK-Genehmigung vor Versorgung abwarten"
    ]
  }
};

export default function VoCheckerPage() {
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const handleCaptureComplete = (dataUrl) => {
    setImage(dataUrl);
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setResult(MOCK_RESULT);
    }, 2000);
  };

  const handleRestart = () => {
    setImage(null);
    setResult(null);
    setLoading(false);
  };

  const renderResult = () => (
    <Box>
      <Paper sx={{ p: 2, mb: 3 }}>
        <Typography variant="h6" gutterBottom>Verordnung</Typography>
        <Typography><strong>Krankenkasse:</strong> {result.verordnung.krankenkasse}</Typography>
        <Typography><strong>Versicherter:</strong> {result.verordnung.versicherter.name}</Typography>
        <Typography><strong>Geburtsdatum:</strong> {result.verordnung.versicherter.geburtsdatum}</Typography>
        <Typography><strong>Verordnungsnummer:</strong> {result.verordnung.verordnungsnummer}</Typography>
        <Typography><strong>Verordnungsdatum:</strong> {result.verordnung.verordnungsdatum}</Typography>
        <Typography><strong>Arzt:</strong> {result.verordnung.arzt.name}</Typography>
        <Typography><strong>Diagnose:</strong> {result.verordnung.diagnose}</Typography>
        <Typography sx={{ mt: 1, fontWeight: 'bold' }}>Hilfsmittel</Typography>
        <Typography>Bezeichnung: {result.verordnung.hilfsmittel.bezeichnung}</Typography>
        <Typography>Produktgruppe: {result.verordnung.hilfsmittel.produktgruppe}</Typography>
        <Typography>HMV-Position: {result.verordnung.hilfsmittel.vermutete_hmv_position}</Typography>
        <Typography>Typ: {result.verordnung.hilfsmittel.typ}</Typography>
        <Typography>Anzahl: {result.verordnung.hilfsmittel.anzahl}</Typography>
        <Typography>Preis: {result.verordnung.hilfsmittel.preis_euro} €</Typography>
      </Paper>
      <Paper sx={{ p: 2, mb: 3 }}>
        <Typography variant="h6" gutterBottom>Prüfung</Typography>
        <Typography>Verordnungswert über Freigrenze: {result.pruefung.verordnungswert_ueber_freigrenze ? 'Ja' : 'Nein'}</Typography>
        <Typography>Genehmigungspflichtig: {result.pruefung.genehmigungspflichtig ? 'Ja' : 'Nein'}</Typography>
        <Typography>Genehmigungsfreigrenze: {result.pruefung.genehmigungsfreigrenze_euro} €</Typography>
        <Typography>Verordnungswert: {result.pruefung.verordnungswert_euro} €</Typography>
        <Typography>Entscheidung: {result.pruefung.entscheidung}</Typography>
        <Typography sx={{ mt: 1, fontWeight: 'bold' }}>Voraussetzungen für die Abgabe</Typography>
        <List>
          {result.pruefung.voraussetzungen_fuer_abgabe.map((v, idx) => (
            <ListItem key={idx} sx={{ display: 'list-item', pl: 2 }}>{v}</ListItem>
          ))}
        </List>
      </Paper>
      <Button variant="contained" onClick={handleRestart}>Neue Verordnung prüfen</Button>
    </Box>
  );

  return (
    <Box sx={{ maxWidth: 800, mx: 'auto', mt: 4 }}>
      <Typography variant="h4" gutterBottom>VO-Checker</Typography>
      {!image && !loading && !result && (
        <DocumentScanner onCaptureComplete={handleCaptureComplete} />
      )}
      {loading && (
        <Box textAlign="center" sx={{ mt: 4 }}>
          <CircularProgress />
          <Typography sx={{ mt: 2 }}>Analyse läuft...</Typography>
        </Box>
      )}
      {result && renderResult()}
    </Box>
  );
}
